import { useQuery, UseQueryResult } from 'react-query'
import { TGiftQueryResult } from '@/src/common/queries/FetchReceivedGiftDetails'
import fetchGiftReceivedDetails from '@/src/common/queries/FetchReceivedGiftDetails'
import { useUser } from '@/src/modules/auth/context/AuthProvider'

const useFetchGiftReceivedDetails = (
    uuid: string
): UseQueryResult<TGiftQueryResult> => {
    const { user, isLoggedIn, isVerified } = useUser()

    return useQuery(
        'fetchGiftReceivedDetails',
        () => fetchGiftReceivedDetails(uuid),
        {
            enabled: !!user && isLoggedIn && isVerified && uuid !== '[...uuid]',
            cacheTime: 0,
        }
    )
}

export default useFetchGiftReceivedDetails
